import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
// evertel
import { Col, InfoBox, Button, useUI } from '@evertel/web/ui'
import { ThreadContext } from '../../Thread'
import { UserTile, useUserProfile } from '@evertel/web/user'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'


const ThreadDirectory = observer(() => {

    const { threadController } = useContext(ThreadContext)
    const { addToast } = useUI()
    const { openUserProfile } = useUserProfile()
    const navigate = useNavigate()
    const sessionService = useService(SessionService, [])

    const leave = async () => {
        try {
            await threadController.closeThread()

            sessionService.deleteThreadFromNavigationHistory(threadController.threadId)

            navigate('/landing')

        } catch (error: any) {
            addToast({
                color: 'danger',
                message: error.message
            })
        }
    }

    const reopen = async () => {
        try {
            await threadController.reopenThread()

            addToast({
                color: 'success',
                message: 'Conversation reopened'
            })

        } catch (error: any) {
            addToast({
                color: 'danger',
                message: error.message
            })
        }
    }

    return (
        <Col>
            {threadController.users?.map((user, idx) =>
                <button
                    key={idx}
                    className="p-3 btn btn-link border-light hover-element"
                    style={{ borderRadius: 0 }}
                    onClick={() => openUserProfile(user.id as number)}
                >
                    <UserTile
                        userId={user.id as number}
                        showPosition
                    />
                </button>
            )}
            {(threadController.isJustMe) &&
                <InfoBox color="info">
                    This is your private space. It's a great place to draft messages, take notes,
                    and keep links and files handy so you can reference them when you need them.
                </InfoBox>
            }
            {(threadController.canLeave) &&
                <Button
                    color="link"
                    onClick={leave}
                    className="mt-5">
                    Leave Conversation
                </Button>
            }
            {(threadController.isClosed) &&
                <Button
                    color="link"
                    onClick={reopen}
                    className="mt-5">
                    Reopen Conversation
                </Button>
            }
        </Col>
    )
})

export { ThreadDirectory }
